import React from "react";
import { BarChart3Icon, ScanFaceIcon, ClipboardListIcon, ShieldCheckIcon, FileTextIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { TransformCTA } from "../TransformCTA";
import { resources } from "../../data/content";
const icons = [BarChart3Icon, ScanFaceIcon, ClipboardListIcon, ShieldCheckIcon, FileTextIcon];
export function Resources() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-261" data-mp="1iz6oezevdxb4">
      <div className="mx-auto max-w-6xl" data-id="element-262" data-mp="1ixlunc0dqieb">
        <SectionHeading kicker="More than six educational volumes" title="Practical resources to complement your Blueprint" intro={["The collection also brings together educational references and practical resources designed to support organized study and documentation."]} data-id="element-263" data-mp="1eymrnwy7kvpi" />

        <ul className="mx-auto mt-12 grid max-w-5xl gap-x-12 md:grid-cols-2" data-id="element-264" data-mp="22o7hmzss4t8a">
          {resources.map((r, i) => {
          const Icon = icons[i];
          return <li key={r.title} className="flex gap-4 border-t border-navy-900/10 py-6" data-id="element-265" data-mp="1akbdlojwqsmm" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-electric text-white" data-id="element-266" data-mp="1fhl2n33dx29x">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-267" data-mp="1jieo7ptcu4zn" />
                </span>
                <div data-id="element-268" data-mp="1ok43xiriv6u2">
                  <h3 className="font-display text-xl font-bold uppercase leading-tight text-ink sm:text-2xl" data-id="element-269" data-mp="1okceh406a023">{r.title}</h3>
                  <p className="mt-1.5 text-base text-muted" data-id="element-270" data-mp="1tgb6d1kpm079">{r.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base text-muted" data-id="element-271" data-mp="2390a1aa0q9s1">
          These resources complement the six volumes and help create a more cohesive educational reference library.
        </p>

        <TransformCTA headline="Get the complete Aesthetic Laser Clinical Blueprint™" label="Access The Collection" data-id="element-272" data-mp="2c9yflx03upcq" />
      </div>
    </section>;
}